import { render, staticRenderFns } from "./Shop.vue?vue&type=template&id=ff0b7f1e&scoped=true"
import script from "./Shop.vue?vue&type=script&lang=js"
export * from "./Shop.vue?vue&type=script&lang=js"
import style0 from "./Shop.vue?vue&type=style&index=0&id=ff0b7f1e&scoped=true&lang=stylus"
import style1 from "./Shop.vue?vue&type=style&index=1&id=ff0b7f1e&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0b7f1e",
  null
  
)

export default component.exports